module.exports = __webpack_public_path__ + "media/success.c354ff15.mp3";